import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

// import { connect } from 'react-redux';

import firebase from 'firebase';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import axios from "../axios-afterschoolmusic";
import { URL_ROOT, FIREBASE_CONFIG } from '../common/globalConstants.js';

const Admin = (props) => {

	const {
		history
	} = props;

	// const [username, setUsername] = useState('');
	// const [password, setPassword] = useState('');
	// const [processing, setProcessing] = useState(false);

	// eslint-disable-next-line
	const [accessToken, setAccesToken] = useState(null);

	// eslint-disable-next-line
	const [user, setUser] = useState(null);

	const [logggedIn, setLoggedIn] = useState(false);

	// eslint-disable-next-line
	const [credential, setCredential] = useState(null);
	const [landingPageBanners, setLandingPageBanners] = useState([]);
	const [calendarList, setCalendarList] = useState([]);
	const [locationList, setLocationList] = useState([]);
	const [pageData, setPageData] = useState([]);

	// eslint-disable-next-line
	const [staffList, setStaffList] = useState([]);

	const [textData, setTextData] = useState([]);
	const [storedImages, setStoredImages] = useState([]);

	const [displayAddTextBlockField, setDisplayAddTextBlockField] = useState(false);

	useEffect(() => {

		if (!firebase.apps.length) {
			firebase.initializeApp(FIREBASE_CONFIG);
		} else {
			firebase.app();
		}

		const provider = new firebase.auth.GoogleAuthProvider();

		firebase.auth()
		.signInWithPopup(provider)
		.then((result) => {
			if(result.credential && result.credential.accessToken && result.credential.accessToken.length > 0 && result.user) {
				if(result.user.email) {
					// if(result.user.email == 'laurencanna@gmail.com') {
					if(result.user.email === 'fjmusick2@gmail.com' || result.user.email === 'laurencanna@gmail.com' || result.user.email === 'fjmusick@hotmail.com' ) {
						setLoggedIn(true);
						setCredential(result.credential);
						setAccesToken(result.credential.accessToken);
						setUser(result.user);
						getData();
					} else {
						setLoggedIn(false);
						history.push(URL_ROOT);
					}
				} else {
					setLoggedIn(false);
					history.push(URL_ROOT);
				}
			} else {
				setLoggedIn(false);
				history.push(URL_ROOT);
			}
		}).catch((error) => {

			console.warn('authError', error);

			history.push(URL_ROOT);
			// var errorCode = error.code;
			// var errorMessage = error.message;
			// var email = error.email;
			// var credential = error.credential;
		});
		// eslint-disable-next-line
	}, []);


	/*
	function uploadRef() {
	var storageRef = firebase.storage().ref();
	var mountainsRef = storageRef.child('mountains.jpg');
	var mountainImagesRef = storageRef.child('images/mountains.jpg');
	mountainsRef.name === mountainImagesRef.name;           // true
	mountainsRef.fullPath === mountainImagesRef.fullPath;   // false
	}

	function uploadBlob(file) {
	const ref = firebase.storage().ref().child('some-child');
	ref.put(file).then((snapshot) => {
	console.log('Uploaded a blob or file!');
	});
	}

	function uploadMetadata(file) {
	const storageRef = firebase.storage().ref();
	var metadata = {
	contentType: 'image/jpeg',
	};

	var uploadTask = storageRef.child('images/mountains.jpg').put(file, metadata);
	}
	*/

	const uploadFile = (fileInput) => {

		if(!fileInput || !fileInput.files) {
			alert('You must select a file');
		}

		if(fileInput.files.length !== 1) {
			alert('You can only upload 1 file at a time');
		}

		const metadata = {
			contentType: fileInput.files[0].type
		};

		const storageRef = firebase.storage().ref();
		const uploadTask = storageRef.child('images/' + fileInput.files[0].name).put(fileInput.files[0], metadata);

		uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, (snapshot) => {
			// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
			const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
			console.log('Upload is ' + progress + '% done');
			switch (snapshot.state) {
				case firebase.storage.TaskState.PAUSED: // or 'paused'
				console.log('Upload is paused');
				break;
				case firebase.storage.TaskState.RUNNING: // or 'running'
				console.log('Upload is running');
				break;
				default:
				console.warn('State: ' + snapshot.state);
				break;
			}
		}, (error) => {
			// A full list of error codes is available at https://firebase.google.com/docs/storage/web/handle-errors
			switch (error.code) {
				default:
				alert('Unable to upload image.  Please try again');
				break;
			}
		}, () => {
			uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
				fileInput.value = '';
				toast.success('Upload successful!');
				// console.log('File available at', downloadURL);
			});
		});
	}

	const updateBanner = (bannerId) => {
		const active = document.getElementById('banner' + bannerId + 'Active');
		const headerText = document.getElementById('banner' + bannerId + 'HeaderText');
		const description = document.getElementById('banner' + bannerId + 'Description');
		const hoverText = document.getElementById('banner' + bannerId + 'HoverText');
		const imageUrl = document.getElementById('banner' + bannerId + 'ImageUrl');
		const linkUrl = document.getElementById('banner' + bannerId + 'LinkUrl');

		if(active != null && headerText != null && description != null && hoverText != null && imageUrl != null && linkUrl != null) {
			/*
			const bannerReference = firebase.database().ref('Banner/' + bannerId);
			bannerReference.on('value', (snapshot) => {
			const data = snapshot.val();
			console.warn('Banner/' + bannerId, data);
			});
			*/

			firebase.database().ref('Banner/' + bannerId).set({
				Active: active.value,
				HeaderText: headerText.value,
				Description : description.value,
				HoverText: hoverText.value,
				ImageUrl: imageUrl.value,
				LinkUrl: linkUrl.value
			}, (error) => {
				if(error) {
					alert('Eror updating data: ' + JSON.stringify(error));
				} else {
					toast.success('Banner ' + bannerId.toString() + ' updated.');
				}
			});
		}
	}

	const updateCalendar = (calendarId) => {
		const title = document.getElementById('calendar' + calendarId + 'Title');
		const url = document.getElementById('calendar' + calendarId + 'Url');

		if(title != null && url != null) {
			/*
			const calendarReference = firebase.database().ref('Calendar/' + calendarId);
			calendarReference.on('value', (snapshot) => {
			const data = snapshot.val();
			console.warn('Calendar/' + calendarId, data);
			});
			*/

			firebase.database().ref('Calendar/' + calendarId).set({
				Title: title.value,
				Url: url.value
			});
		}
	}

	const updateLocation = (locationId) => {
		const city = document.getElementById('currentLocation' + locationId + 'City');
		const country = document.getElementById('currentLocation' + locationId + 'Country');
		const locationState = document.getElementById('currentLocation' + locationId + 'State');
		const registrationEmail = document.getElementById('currentLocation' + locationId + 'RegistrationEmail');
		const facebookUrl = document.getElementById('currentLocation' + locationId + 'FacebookUrl');

		if(city != null && country != null && locationState != null && registrationEmail != null) {
			firebase.database().ref('Location/' + locationId).set({
				Address: {
					City: city.value,
					Country: country.value,
					State: locationState.value,
				},
				FacebookUrl: facebookUrl.value,
				RegistrationEmail: registrationEmail.value
			});
		}

	}

	const updateTextBlock = (textBlockId) => {
		const isHtml = document.getElementById('textBlock' + textBlockId + 'IsHtml');
		const bodyText = document.getElementById('textBlock' + textBlockId + 'BodyText');

		if(isHtml != null && bodyText != null) {
			firebase.database().ref('TextBlock/' + textBlockId).set({
				IsHtml: isHtml.value,
				BodyText: bodyText.value
			});
		}
	}

	const showAddTextBlockField = () => {
		setDisplayAddTextBlockField(true);
	}

	const addTextBlock = () => {
		return false;
	}

	const updatePage = (pageId) => {
		const component = document.getElementById('page' + pageId + 'Component');
		const location = document.getElementById('page' + pageId + 'Location');
		const menuText = document.getElementById('page' + pageId + 'MenuText');
		const description = document.getElementById('page' + pageId + 'Description');
		const title = document.getElementById('page' + pageId + 'Title');
		const url = document.getElementById('page' + pageId + 'Url');
		const showInMenu = document.getElementById('page' + pageId + 'ShowInMenu');

		if(component != null && location != null && menuText != null && description != null && title != null && url != null && showInMenu != null) {
			firebase.database().ref('LocatiionPage/' + pageId).set({
				Component: component.value,
				LocationId: location.value,
				MenuText: menuText.value,
				PageDescription: description.value,
				PageTitle: title.value,
				PageUrl: url.value,
				ShowInMenu: showInMenu.value
			});
		}

	}

	const movePageTextBlockDown = (page, textBlock) => {
		return false;
	}

	const movePageTextBlockUp = (page, textBlock) => {
		return false;
	}

	const removePageTextBlock = (page, textBlock) => {
		return false;
	}

	const moveSubmenuItemDown = (page, textBlock) => {
		return false;
	}

	const moveSubmenuItemUp = (page, textBlock) => {
		return false;
	}

	const removeSubmenuItem = (page, textBlock) => {
		return false;
	}


	const getData = () => {

		const banners = [];
		const calendars = [];
		const locations = [];
		const locationPages = [];
		const staffData = [];
		const textBlocks = [];

		axios.get('/Banner.json')
		.then(response => {
			const bannerDataKeys = Object.keys(response.data);
			for (let i = 0; i < bannerDataKeys.length; i++) {
				if(response.data[bannerDataKeys[i]] && response.data[bannerDataKeys[i]].Active) {
					banners.push({
						...response.data[bannerDataKeys[i]],
						id: bannerDataKeys[i]
					});
				}
			}

			axios.get('/Calendar.json')
			.then(response => {
				const calendarDataKeys = Object.keys(response.data);
				for (let i = 0; i < calendarDataKeys.length; i++) {
					calendars.push({
						...response.data[calendarDataKeys[i]],
						id: calendarDataKeys[i]
					});
				}

				axios.get('/Staff.json')
				.then(response => {
					const staffDataKeys = Object.keys(response.data);
					if(staffDataKeys && staffDataKeys.length > 0) {
						for (let i = 0; i < staffDataKeys.length; i++) {
							staffData.push({
								...response.data[staffDataKeys[i]],
								id: staffDataKeys[i]
							});
						}

						axios.get('/TextBlock.json')
						.then(response => {
							const textBlockDataKeys = Object.keys(response.data);
							if(textBlockDataKeys && textBlockDataKeys.length > 0) {
								for (let i = 0; i < textBlockDataKeys.length; i++) {
									textBlocks.push({
										...response.data[textBlockDataKeys[i]],
										id: textBlockDataKeys[i]
									});
								}

								axios.get('/Location.json')
								.then(response => {
									const locationDataKeys = Object.keys(response.data);
									if(locationDataKeys && locationDataKeys.length > 0) {
										for (let i = 0; i < locationDataKeys.length; i++) {
											locations.push({
												...response.data[locationDataKeys[i]],
												id: locationDataKeys[i]
											});
										}

										axios.get('/LocationPage.json')
										.then(response => {
											const locationPageDataKeys = Object.keys(response.data);
											if(locationPageDataKeys && locationPageDataKeys.length > 0) {
												for (let i = 0; i < locationPageDataKeys.length; i++) {
													/*
													const locationPage = response.data[locationPageDataKeys[i]];
													const currentPage = {
													id: locationPageDataKeys[i],
													menuText: locationPage.MenuText,
													component: locationPage.Component,
													url: locationPage.PageUrl,
													locationId: locationPage.LocationId,
													pageTitle: locationPage.PageTitle,
													pageDescription: locationPage.PageDescription,
													textBlocks: locationPage.TextBlocks,
													subMenuItems: locationPage.SubmenuItems,
													showInMenu: locationPage.ShowInMenu
													};

													locationPages.push(currentPage);
													*/
													locationPages.push({
														...response.data[locationPageDataKeys[i]],
														id: locationPageDataKeys[i]
													});
												}

												setLandingPageBanners(banners);
												setCalendarList(calendars);
												setLocationList(locations);
												setPageData(locationPages);
												setStaffList(staffData);
												setTextData(textBlocks);
											}
										})
										.catch(error => {
											console.warn("Error", error);
										});
									}
								})
								.catch(error => {
									console.warn("Error", error);
								});
							}
						})
						.catch(error => {
							console.warn("Error", error);
						});
					}
				})
				.catch(error => {
					console.warn("Error", error);
				});
			})
			.catch(error => {
				console.warn("Error", error);
			});

		})
		.catch(error => {
			console.warn("Error", error);
		});

		const imageData = [];
		const storageReference = firebase.storage().ref();
		const listReference = storageReference.child('images');
		listReference.listAll().then((resource) => {
			resource.items.forEach((itemReference) => {
				itemReference.getDownloadURL().then((url) => {
					console.warn('itemReference', itemReference);

					const currentImage = {
						fullPath: itemReference.fullPath,
						url: url
					};

					imageData.push(currentImage);
				});
			});
			setStoredImages(imageData);
		});

	}

	let loginForm = null;
	/*
	loginForm = (
	<React.Fragment>
	<h1>Login</h1>
	<label htmlFor='usernameField'>Email Address:</label>
	<input id='usernameField' type='text' value={username} onChange={(e) => setUsername(e.target.value)} />
	<br />
	<label htmlFor='passwordField'>Password:</label>
	<input id='passwordField' type='text' value={password} onChange={(e) => setPassword(e.target.value)} />
	<button className='submit' onClick={login} disabled={processing}>Login</button>
	</React.Fragment>
	);
	*/

	let editorPage = null;

	if(logggedIn) {
		let banners = null;
		let locations = null;
		let calendars = null;
		let textBlocks = null;
		let images = null;
		let pages = null;
		let addTextBlockFields = null;

		if(landingPageBanners && landingPageBanners.length > 0) {
			banners = landingPageBanners.map((banner, index) => {
				return (
					<div key={banner.id}>
						<h2>Banner {banner.id.toString()}</h2>
						<label htmlFor={'banner' + banner.id + 'Active'}>Active</label>
						<input id={'banner' + banner.id + 'Active'} type='checkbox'  defaultChecked={banner.Active} />
						<br />

						<label htmlFor={'banner' + banner.id + 'HeaderText'}>Header Text</label>
						<input id={'banner' + banner.id + 'HeaderText'} type='text'  defaultValue={banner.HeaderText} />
						<br />

						<label htmlFor={'banner' + banner.id + 'Description'}>Description</label>
						<input id={'banner' + banner.id + 'Description'} type='text'  defaultValue={banner.Description} />
						<br />

						<label htmlFor={'banner' + banner.id + 'HoverText'}>Hover Text</label>
						<input id={'banner' + banner.id + 'HoverText'} type='text'  defaultValue={banner.HoverText} />
						<br />

						<label htmlFor={'banner' + banner.id + 'ImageUrl'}>Image</label>
						<input id={'banner' + banner.id + 'ImageUrl'} type='text'  defaultValue={banner.ImageUrl} disabled />
						<br />

						<label htmlFor={'banner' + banner.id + 'LinkUrl'}>Link Url</label>
						<input id={'banner' + banner.id + 'LinkUrl'} type='text'  defaultValue={banner.LinkUrl} />
						<br />

						<button onClick={() => { updateBanner(banner.id); }}>Save Changes</button>
					</div>
				);
			});
		}

		if(calendarList && calendarList.length > 0) {
			calendars = calendarList.map((calendar, index) => {
				return (
					<div key={calendar.id}>
						<h2>Calendar {calendar.id.toString()}</h2>
						<label htmlFor={'calendar' + calendar.id + 'Title'}>Title</label>
						<input id={'calendar' + calendar.id + 'Title'} type='text'  defaultValue={calendar.Title} />
						<br />

						<label htmlFor={'calendar' + calendar.id + 'Url'}>Url</label>
						<input id={'calendar' + calendar.id + 'Url'} type='text'  defaultValue={calendar.Url} />
						<br />

						<button onClick={() => { updateCalendar(calendar.id); }}>Save Changes</button>
					</div>
				);
			});
		}

		if(locationList && locationList.length > 0) {
			locations = locationList.map((currentLocation, index) => {
				return (
					<div key={currentLocation.id}>
						<h2>Location {currentLocation.id.toString()}</h2>
						<label htmlFor={'currentLocation' + currentLocation.id + 'RegistrationEmail'}>Registration Email</label>
						<input id={'currentLocation' + currentLocation.id + 'RegistrationEmail'} type='text'  defaultValue={currentLocation.RegistrationEmail} />
						<br />

						<label htmlFor={'currentLocation' + currentLocation.id + 'FacebookUrl'}>Facebook Page Url</label>
						<input id={'currentLocation' + currentLocation.id + 'FacebookUrl'} type='text'  defaultValue={currentLocation.FacebookUrl} />
						<br />

						{currentLocation.Address && (
							<React.Fragment>
								<h3>Address</h3>
								<label htmlFor={'currentLocation' + currentLocation.id + 'City'}>City</label>
								<input id={'currentLocation' + currentLocation.id + 'City'} type='text'  defaultValue={currentLocation.Address.City} />
								<br />

								<label htmlFor={'currentLocation' + currentLocation.id + 'State'}>State</label>
								<input id={'currentLocation' + currentLocation.id + 'State'} type='text'  defaultValue={currentLocation.Address.State} />
								<br />

								<label htmlFor={'currentLocation' + currentLocation.id + 'Country'}>Country</label>
								<input id={'currentLocation' + currentLocation.id + 'Country'} type='text'  defaultValue={currentLocation.Address.Country} />
								<br />
							</React.Fragment>
						)}

						<button onClick={() => { updateLocation(currentLocation.id); }}>Save Changes</button>
					</div>
				);
			});
		}

		if(textData && textData.length > 0) {
			textBlocks = textData.map((textBlock, index) => {
				return (
					<div key={textBlock.id}>
						<h2>Text Block {textBlock.id.toString()}</h2>
						<label htmlFor={'textBlock' + textBlock.id + 'IsHtml'}>Is HTML?</label>
						<input id={'textBlock' + textBlock.id + 'IsHtml'} type='checkbox' defaultChecked={textBlock.IsHtml} />
						<br />

						<label htmlFor={'textBlock' + textBlock.id + 'BodyText'}>Text</label>
						<input id={'textBlock' + textBlock.id + 'BodyText'} type='text' defaultValue={textBlock.BodyText} />
						<br />

						<button onClick={() => { updateTextBlock(textBlock.id); }}>Save Changes</button>
					</div>
				);
			});

			textBlocks.push(
				<button key={textData.length} onClick={showAddTextBlockField}>Add New Text Block</button>
			);

		}

		if(pageData && pageData.length > 0) {
			pages = pageData.map((page, index) => {
				let pageTextBlocks = null;
				let submenuItems = null;

				if(page.TextBlocks) {
					const sortedTextBlocks = page.TextBlocks.sort((a, b) => (a.Order > b.Order) ? 1 : -1);
					pageTextBlocks = sortedTextBlocks.map((pageTextBlock, textBlockIndex) => {
						return (
							<div key={pageTextBlock.id}>
								<select className='textBlockDropDown' value={pageTextBlock.TextBlockId}>
									{textData.map((textBlock) => (
										<option value={textBlock.id}>{textBlock.BodyText}</option>
									))}
								</select>
								{(pageTextBlock.Order > 0) && <button className='changeTextBlockOrder' alt='Move Up' title='Move Up' onClick={movePageTextBlockUp(page, pageTextBlock)}>{'\u{1F815}'}</button>}
								{(pageTextBlock.Order < (sortedTextBlocks.length - 1)) && <button className='changeTextBlockOrder' alt='Move Down' title='Move Down' onClick={movePageTextBlockDown(page, pageTextBlock)}>{'\u{1F817}'}</button>}
								<button className='changeTextBlockOrder' alt='Delete' title='Delete' onClick={() => { removePageTextBlock(page, pageTextBlock); }}>{'\u{20E0}'}</button>
								<br />
							</div>
						);
					});
					pageTextBlocks.unshift(<h3>Text Blocks</h3>);
				}

				if(page.SubmenuItems) {
					const sortedMenuItems = page.SubmenuItems.sort((a, b) => (a.Order > b.Order) ? 1 : -1);
					submenuItems = sortedMenuItems.map((menuItem, menuItemIndex) => {
						// eslint-disable-next-line
						const matchingPage = pageData.filter(x => x.id == menuItem.LocationPageId);
						if(matchingPage != null && matchingPage.length === 1) {
							const currentSubmenuItem = matchingPage[0];

							return (
								<div key={'page' + page.Id + 'submenu' + menuItemIndex}>
									<select className='submenuDropDown' value={currentSubmenuItem.id}>
										{pageData.map((submenuPage) => (
											<option value={submenuPage.id}>{submenuPage.MenuText}</option>
										))}
									</select>
									{(currentSubmenuItem.Order > 0) && <button className='changeSubmenuOrder' alt='Move Up' title='Move Up' onClick={moveSubmenuItemUp(page, currentSubmenuItem)}>{'\u{1F815}'}</button>}
									{(currentSubmenuItem.Order < (sortedMenuItems.length - 1)) && <button className='changeSubmenuOrder' alt='Move Down' title='Move Down' onClick={moveSubmenuItemDown(page, currentSubmenuItem)}>{'\u{1F817}'}</button>}
									<button className='changeSubmenuOrder' alt='Delete' title='Delete' onClick={() => { removeSubmenuItem(page, currentSubmenuItem); }}>{'\u{20E0}'}</button>
									<br />
								</div>
							);
						} else {
							return null;
						}
					});
					submenuItems.unshift(<h3>Submenu Items</h3>);
				}

				return (
					<div key={page.id}>
						<h2>Page {page.id.toString()}</h2>
						<label htmlFor={'page' + page.id + 'Template'}>Template</label>
						<input id={'page' + page.id + 'Template'} type='text' defaultValue={page.Component} />
						<br />

						<label htmlFor={'page' + page.id + 'Location'}>Location</label>
						<input id={'page' + page.id + 'Location'} type='text' defaultValue={page.LocationId} />
						<br />

						<label htmlFor={'page' + page.id + 'MenuText'}>Menu Text</label>
						<input id={'page' + page.id + 'MenuText'} type='text' defaultValue={page.MenuText} />
						<br />

						<label htmlFor={'page' + page.id + 'Description'}>Description</label>
						<input id={'page' + page.id + 'Description'} type='text' defaultValue={page.PageDescription} />
						<br />

						<label htmlFor={'page' + page.id + 'Title'}>Title</label>
						<input id={'page' + page.id + 'Title'} type='text' defaultValue={page.PageTitle} />
						<br />

						<label htmlFor={'page' + page.id + 'Url'}>Url</label>
						<input id={'page' + page.id + 'Url'} type='text' defaultValue={page.PageUrl} />
						<br />

						<label htmlFor={'page' + page.id + 'ShowInMenu'}>Show in Menu</label>
						<input id={'page' + page.id + 'ShowInMenu'} type='checkbox' defaultChecked={page.ShowInMenu} />
						<br />

						{pageTextBlocks}
						{submenuItems}

						<button onClick={() => { updatePage(page.id); }}>Save Changes</button>
					</div>
				);
			});
		}

		if(displayAddTextBlockField  && displayAddTextBlockField === true) {
			addTextBlockFields = (
				<div className='fullWidth'>
					<label htmlFor='nextTextBlockText'>Text</label>
					<input id='nextTextBlockText' type='text' />
					<br />
					<label htmlFor='nextTextBlockIsHtml'>Is HTML?</label>
					<input id='nextTextBlockIsHtml' type='checkbox' />
					<br />
					<button onClick={addTextBlock}>Add</button>
				</div>
			);
		}

		if(storedImages && storedImages.length > 0) {

			images = storedImages.map((image, index) => {
				return (
					<div key={index}>
						<p>{image.fullPath}</p>
						<img src={image.url} alt={image.fullPath} />
						<br />
						<br />
					</div>
				);
			});
		}

		editorPage = (
			<React.Fragment>
				<h1>Banners</h1>
				{banners}
				<h1>Locations</h1>
				{locations}
				<h1>Text Blocks</h1>
				{textBlocks}
				{addTextBlockFields}
				<h1>Calendars</h1>
				{calendars}
				<h1>Pages</h1>
				{pages}
				<h1>Images</h1>
				{images}
				<label htmlFor='newImage'>Upload New Image:</label>
				<input type='file' id='newImage' onChange={(e) => uploadFile(e.target)} />
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<header></header>
			<main id="adminPage">
				<ToastContainer />
				<div className='content'>
					<div className='pageContent'>
						{loginForm}
						{editorPage}
					</div>
				</div>
			</main>
			<footer></footer>
		</React.Fragment>
	);
};

export default withRouter(Admin);
